<template>
  <AkFileUploader
    ref="fileUploader"
    :above-max-file-size-message="
      t('The file size is too big. Maximum upload size is {xx} Mb', { xx: MAX_FILE_SIZE_IN_MEGABYTES })
    "
    :drag-label="t('Add images')"
    :max-file-size="MAX_FILE_SIZE"
    :primary-label="t('brand.account.products.form.dragAndDropYourFilesHere')"
    :secondary-label="t('brand.account.products.form.browseYourComputer')"
    :size-label="t('Max {xx} Mb.', { xx: MAX_FILE_SIZE_IN_MEGABYTES })"
    :types-label="t('brand.account.products.form.acceptedImageFormats')"
    :unaccepted-type-message="t('brand.account.products.form.invalidImageFormat')"
    :uploaded-file-label-max-length="MAX_FILE_SIZE"
    :accepted-types="ACCEPTED_TYPES.IMAGES"
    :max-file-quantity="1000"
    :disabled="disabled"
    hide-files
    require
    multiple
    @change="emit('change', $event)"
  />
</template>
<script setup lang="ts">
import { AkFileUploader } from '@ankorstore/design-system';
import { MAX_FILE_SIZE_IN_MEGABYTES, MAX_FILE_SIZE, ACCEPTED_TYPES } from '../../constants';
import { useI18n } from 'vue-i18n';

withDefaults(
  defineProps<{
    disabled: boolean;
  }>(),
  {
    disabled: false,
  }
);

const { t } = useI18n();
const emit = defineEmits(['change']);
</script>
<style scoped lang="scss">
@import '@css/vue-import';
</style>
